<div class="container main-font">
  <div *nzModalTitle class="section-title">
    Concludi collaborazione
  </div>
  <div>
    <form [formGroup]="deleteUser">
      <nz-row class="w-100 justify-content-between gap-3">
        <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" [nzXl]="24">
          <small class="text-danger">
            L'utente concluderà la sua collaborazione, i dati relativi alla sua partecipazione nel team verranno salvati.
          </small>
        </nz-col>
      </nz-row>
      <nz-row nzAlign="middle" class="mt-2">
        <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" [nzXl]="24">
          <mat-form-field appearance="fill" color="accent" class="picker_pos custom-height no-underline">
            <mat-label>Inserisci una data di conclusione:</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              id="endwork_date"
              formControlName="endwork_date"
              [min]="startDate"
              [max]="endDate"
              class="form-control w-100"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </nz-col>
      </nz-row>
      <nz-row nzAlign="middle" class="mt-2">
        <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" [nzXl]="24">
          <mat-checkbox formControlName="billing" id="billing">
            <label class="form-check-label" for="billing">
              Rimuovi dallo sprint in corso
            </label>
          </mat-checkbox>
        </nz-col>
      </nz-row>
    </form>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="handleCancel()" class="close">Annulla</button>
    <button nz-button class="save" nzType="primary" (click)="delMember()" [disabled]="!deleteUser.valid">Conferma</button>
  </div>
</div>